var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.367 1.50514C11.367 0.677315 10.7652 0 10.0297 0H8.02374V1.50514H10.0297V3.49946L7.70279 6.77315H5.34916V3.01029H2.67458C1.19687 3.01029 0 4.35739 0 6.02058V8.27829H1.33729C1.33729 9.52756 2.23327 10.536 3.34323 10.536C4.45318 10.536 5.34916 9.52756 5.34916 8.27829H8.34469L11.367 4.02626V1.50514ZM3.34323 9.03087C2.97547 9.03087 2.67458 8.69221 2.67458 8.27829H4.01187C4.01187 8.69221 3.71098 9.03087 3.34323 9.03087Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34909 0.752563H2.00586V2.25769H5.34909V0.752563Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.367 6.02057C10.2571 6.02057 9.36108 7.02901 9.36108 8.27827C9.36108 9.52754 10.2571 10.536 11.367 10.536C12.477 10.536 13.373 9.52754 13.373 8.27827C13.373 7.02901 12.477 6.02057 11.367 6.02057ZM11.367 9.03084C10.9993 9.03084 10.6984 8.69219 10.6984 8.27827C10.6984 7.86436 10.9993 7.52571 11.367 7.52571C11.7348 7.52571 12.0357 7.86436 12.0357 8.27827C12.0357 8.69219 11.7348 9.03084 11.367 9.03084Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/Delivery.ba9bd45e7d2bfe7c99368b4e6a665983.svg";
export { ForwardRef as ReactComponent };